import { Component, EventEmitter } from '@angular/core';
import { UICallHistoryItem } from '../../models/company-call-history/company-call-history.model';
import { UtilsService } from '../../services';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IPhoneCallTag, PhoneCallDirections } from 'voxloud-types/dist/models';
import { StartCallModalComponent } from '../start-call-modal/start-call-modal.component';
import { CallService } from '../../../core/services';

@Component({
  selector: 'company-call-history-detail',
  templateUrl: './company-call-history-detail.component.html',
  styleUrls: ['./company-call-history-detail.component.scss']
})
export class CompanyCallHistoryDetailComponent {

  public callItem: UICallHistoryItem;
  public language: string = 'it';
  public generalNavTabActive: string = 'general';
  public recordingNavTabActive: string = 'call-recording';
  public PhoneCallDirections = PhoneCallDirections;

  public allTags: IPhoneCallTag[];
  public tagsApiFailed: boolean = false;

  public updateCallLog: EventEmitter<UICallHistoryItem> = new EventEmitter();
  public fetchTags: EventEmitter<void> = new EventEmitter();

  constructor(
    private activeModal: NgbActiveModal,
    private utilService: UtilsService,
    private callService: CallService
  ){}

  public close() {
    this.activeModal.close();
  }

  public callNumber(number: string):void {
    this.callService.callFromNumber(number);
    this.close();
  }

  public openLink(link: string): void {
    this.utilService.openExternalLink(link);
  }

  public onUpdatedCallLog(callLog: UICallHistoryItem): void {
    this.callItem = callLog;
    this.updateCallLog.emit(callLog);
  }
  
}
